'use strict'
import axios from "axios";
import store from '../store';
import { ClientJS } from 'clientjs';

export default class TrackEvent {
    static clientjs = new ClientJS();

    static track(data) {
        process.env.NODE_ENV === 'development' ? this.fakeTrack(data) : this.dispatch(data);
    }

    static dispatch(data) {
        axios.post( `../${store.getters.getConfig['analytics_url']}`, data, {
            headers: {
                'access_key': store.getters.getAccessKey,
                'metadata': store.getters.getMetadataCookie,
                'tid': null,
                'schema': 'bi',
            }
        });
    }

    static getChannel() {
        return {
            name: '7',
            deviceOS: this.clientjs.getOS(),
            deviceModel: this.clientjs.getDevice(),
            deviceManufacturer: this.clientjs.getDeviceVendor(),
            appVersion: this.clientjs.getOSVersion(),
        };
    }

    static fakeTrack(data) {
        console.log('Development: ' + store.getters.getConfig['analytics_url'], data);
    }

}
